import { FC } from 'react';
import cx from 'classnames';

import { externalLinks } from '@/config';
import { AppImage, Skeleton } from '@/components';

import iconTelegramColor from '@/assets/images/socials/logo-telegram-color.svg';

import styles from './SocialsContact.module.sass';

interface SocialsContactProps {
  className?: string;
}

const SocialsContact: FC<SocialsContactProps> = ({ className }) => {
  return (
    <div className={cx(styles.socials, className)}>
      <a
        href={externalLinks.TELEGRAM_SUPPORT_BOT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.social}
      >
        <AppImage
          src={iconTelegramColor}
          alt="Telegram Icon"
          fallback={<Skeleton width={80} height={80} border="50%" />}
        />
        <span>Telegram</span>
      </a>
    </div>
  );
};

export default SocialsContact;
